<ng-scrollbar pointerEventsMethod="scrollbar"> 
    <div id="vertical-menu" class="menu-wrapper"></div>
</ng-scrollbar>